module.exports = __webpack_public_path__ + "img/1535729419.58b38dc0.jpg";